<template>
  <v-hover #default="{hover}">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      class="base-button font-weight-regular"
      :color="cancel ? 'white' : color"
      :outlined="cancel || toggleable"
      :class="{ hover: hover, 'font--text': cancel, cancel: cancel }"
      :dark="!$attrs.disabled"
      :loading="loading"
      :style="buttonStyle"
    >
      <v-icon v-if="icon" v-text="icon" :size="iconSize"></v-icon>
      {{ computedText }}
    </v-btn>
  </v-hover>
</template>

<script>
export default {
  name: 'BaseButton',
  inheritAttrs: false,
  props: {
    /**
     * @type {('primary'|'success'|'error')} color=primary kolor
     */
    color: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: String,
      default: '16px',
    },
    icon: {
      type: String,
      default: '',
    },
    translationPath: {
      type: String,
      default: '',
    },
    isPlural: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: Number,
      default: 0,
    },
    /**
     * text that should not be translated, e.g layer card text.
     */
    straightText: {
      type: String,
      default: '',
    },
    cancel: {
      type: Boolean,
      default: false,
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    translationMethod() {
      return this.isPlural ? 'tc' : 't';
    },
    computedText() {
      return this.straightText
        ? this.straightText
        : this.$i18n[this.translationMethod](this.translationPath, this.amount);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  &.v-btn {
    letter-spacing: 0.0178571429em !important;
    min-width: 70px !important;
    border-radius: 2px !important;
    &.v-size--default {
      margin-right: 18px;
      font-size: 14px !important;
      height: 32px;
      padding: 8px 16px;
    }
    &.hover {
      filter: brightness(105%);
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    }
    & .v-btn__content {
      text-transform: initial;
      font-weight: 500;
      & .v-icon {
        padding-right: 6px !important;
      }
    }
    &.cancel {
      border-color: rgba(0, 0, 0, 0.2);
      &:hover {
        box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 8px 0 rgba(0, 0, 0, 0.12) !important;
      }
    }
  }
}
</style>
